import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/progressButton.svg'
import _imports_1 from '@/assets/volume.svg'
import _imports_2 from '@/assets/mute.svg'
import _imports_3 from '@/assets/playButton.svg'
import _imports_4 from '@/assets/pause.svg'
import _imports_5 from '@/assets/volumeFaded.svg'
import _imports_6 from '@/assets/PlayFaded.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-70a38c14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-lightgrey h-20 width relative controlBar rounded-b-lg" }
const _hoisted_2 = { class: "mx-2.5 top-3 w-inherit relative" }
const _hoisted_3 = { class: "h-1.5 bg-white rounded-2xl w-full absolute" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "playButton"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex justify-center items-center mt-4" }
const _hoisted_7 = { class: "flex justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-11" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "VolFaded"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "PlayFaded"
  })
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "bg-primary rounded-2xl h-full w-0 absolute z-50 flex justify-end",
          ref: "progress",
          style: _normalizeStyle(_ctx.progress)
        }, [
          (_ctx.playerButton)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex justify-between relative top-3 text-xs", {'h-4':_ctx.totalDuration ==''}])
      }, [
        (_ctx.totalDuration !=='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.currentPosition), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, _toDisplayString(_ctx.totalDuration), 1)
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass({'hidden':!_ctx.totalDuration,'block':_ctx.totalDuration})
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mute && _ctx.mute(...args)), ["stop"])),
              class: _normalizeClass(["mr-11", {'pointer-events-none':_ctx.totalDuration =='','cursor-pointer':_ctx.totalDuration!=''}])
            }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Mute",
                class: _normalizeClass({'hidden':_ctx.toggleMute,'block':!_ctx.toggleMute})
              }, null, 2),
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Volume",
                class: _normalizeClass({'hidden':!_ctx.toggleMute,'block':_ctx.toggleMute})
              }, null, 2)
            ], 2),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playPause && _ctx.playPause(...args)), ["stop"])),
              class: _normalizeClass({'pointer-events-none':_ctx.totalDuration =='','cursor-pointer':_ctx.totalDuration!=''})
            }, [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "Pause",
                class: _normalizeClass({'hidden':_ctx.togglePlay,'block':!_ctx.togglePlay})
              }, null, 2),
              _createElementVNode("img", {
                src: _imports_4,
                alt: "Play",
                class: _normalizeClass({'hidden':!_ctx.togglePlay,'block':_ctx.togglePlay})
              }, null, 2)
            ], 2)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["flex justify-center items-center", {'hidden':_ctx.totalDuration,'block':!_ctx.totalDuration}])
        }, _hoisted_10, 2)
      ])
    ])
  ]))
}